type Flush = () => Promise<void>;

const pendingFlushes = new Map<string, Flush>();

export const registerEntityReviewFlush = (
  entityId: string,
  flush: Flush
): void => {
  pendingFlushes.set(entityId, flush);
};

export const unregisterEntityReviewFlush = (entityId: string): void => {
  pendingFlushes.delete(entityId);
};

export const flushEntityReviewSaves = async (): Promise<void> => {
  await Promise.all(Array.from(pendingFlushes.values(), (flush) => flush()));
};
